import { useBotInfo } from "../contexts/BotContext";
import "./Login.css";
import { useTheme } from "../contexts/ThemeContext";

function Login() {
  const { isDarkMode, toggleTheme } = useTheme();
  const { botInfo } = useBotInfo();
  const serverCount = botInfo?.guildCount;
  const formattedServerCount =
    typeof serverCount === "number" ? serverCount.toLocaleString() : "...";

  const handleLogin = () => {
    // Use relative path so it works in both development and production
    // In development: http://localhost:5173/auth/discord → proxied to localhost:3000
    // In production: https://yourdomain.com/auth/discord → served by same origin
    window.location.href = "/auth/discord";
  };

  return (
    <div className="login-container">
      <button
        className="login-theme-toggle"
        onClick={toggleTheme}
        title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
      >
        {isDarkMode ? "☀️" : "🌙"}
      </button>
      <div className="login-card">
        <div className="login-header">
          {botInfo?.avatarURL ? (
            <img
              src={botInfo.avatarURL}
              alt="Bot Avatar"
              className="login-bot-avatar"
            />
          ) : (
            <div className="login-bot-icon">🤖</div>
          )}
          <h1>{botInfo?.username || "Discord Bot"} Panel</h1>
        </div>
        <div className="login-stats">
          <div className="login-stat">
            <span className="login-stat-value">{formattedServerCount}</span>
            <span className="login-stat-label">Servers served</span>
          </div>
        </div>
        <p className="login-description">
          Sign in with Discord to access the dashboard
        </p>
        <button onClick={handleLogin} className="login-btn">
          Login with Discord
        </button>
        <div className="login-features">
          <h2>What you can do</h2>
          <ul className="login-feature-list">
            <li>
              <span className="login-feature-title">Reaction Roles</span>
              <p>
                Let members self-assign roles by reacting to curated messages.
              </p>
            </li>
            <li>
              <span className="login-feature-title">Webhook triggers</span>
              <p>
                Track key activity to trigger webhooks, perfect for tools like
                n8n
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Login;
